import styled from 'styled-components';
import { colors } from '../../../../const/color';

export const FormCheckboxToggleStyled = styled('span')`
  width: 28px;
  height: 16px;
  border-radius: 12px;
  background-color: ${colors.transparent};
  border: 1px solid ${colors.primary};
  display: block;
  position: relative;
  cursor: pointer;
  margin-right: 10px;

  &:after {
    width: 12px;
    height: 12px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50%;
    background-color: ${colors.primary};
    content: '';
    left: 2px;
    right: auto;
    cursor: pointer;
  }
`;
